module.exports = __webpack_public_path__ + "img/icon--availability.b9be168d.svg";